import { mergeWith } from 'lodash'
import type { ViewerStatus } from '@wix/wix-data-client-common'

const COMPONENT_TO_PROPS_EMPTY_FIELDS_KEY =
  'componentToPropertiesConnectedToEmptyFields' as const satisfies keyof ViewerStatus

const customizer = (
  objValue: ViewerStatus[keyof ViewerStatus] | undefined,
  srcValue: ViewerStatus[keyof ViewerStatus],
  key?: keyof ViewerStatus,
): ViewerStatus[keyof ViewerStatus] | undefined => {
  if (key === COMPONENT_TO_PROPS_EMPTY_FIELDS_KEY) {
    return srcValue
  }

  return undefined
}

export const createViewerStatus = () => {
  let viewerStatus = {}
  let viewerStatusMessage = ''
  return {
    get: () => viewerStatus,
    update: (_viewerStatusMessage: string): boolean => {
      viewerStatus = mergeWith(
        {},
        viewerStatus,
        JSON.parse(_viewerStatusMessage),
        customizer,
      )
      const newViewerStatusMessage = JSON.stringify(viewerStatus)
      if (newViewerStatusMessage === viewerStatusMessage) {
        return false
      }
      viewerStatusMessage = newViewerStatusMessage
      return true
    },
  }
}
